// MODULES
import React from "react";

// COMPONENTS
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import OptionsList from "@routes/Cob/components/OptionsList/OptionsList";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class Collection extends React.PureComponent {

	render() {
		const {props} = this;
		const {index, fields, onOptionsListChange} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		return (
			<div className={classes}>
				<h3>Produktklasser</h3>

				<FieldsCollection
					fields={[
						{
							render: (
								<FieldsCollection
									fields={[
										{
											render: (
												<React.Fragment>
													<h4>Produktklass A</h4>
													<div className="subtitle">Icke komplexa produkter</div>
													<div className="description">
														<p>I Produktklass A ingår t.ex. aktier, fonder, räntebärande
															produkter och obligationer.</p>
													</div>
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_product_class_a"
														description="Jag förstår risken i produkterna i Produktklass A"
														options={fields.radio_product_class_a.options}
														onChange={onOptionsListChange}
													/>
												</React.Fragment>
											),
										},
									]}
								/>
							),
						}, {
							render: (
								<FieldsCollection
									fields={[
										{
											render: (
												<React.Fragment>
													<h4>Produktklass B</h4>
													<div className="subtitle">Komplexa produkter</div>
													<OptionsList
														type="radio"
														orientation="horizontal"
														name="radio_product_class_b"
														description="Jag förstår risken i produkterna i Produktklass B"
														options={fields.radio_product_class_b.options}
														onChange={onOptionsListChange}
													/>
												</React.Fragment>
											),
										},
									]}
								/>
							),
						},
					]}
				/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/nordfk-cob/Fields/collections/CollectionProductClass.js